import React, { useState } from "react";
import ErrorText from "../ErrorText/ErrorText";
import styles from "../Input/Input.module.scss";
import { Form } from "react-bootstrap";

const Textarea = ({ variant, name, className, type, rows, label, icon, formik, ...rest }) => {
	return (
		<div className={`${styles.input} ${className || ""}`} data-variant={variant}>
			{label && <label htmlFor={name}>{label}</label>}
			<div className={`${styles.input_inner} ${styles.icon_input}`}>
				<Form.Control
					className={styles.fieldtextarea}
					name={name}
					id={name}
					type={type}
					as="textarea"
					rows={rows || 3}
					{...rest}
				/>
			</div>
			{formik?.touched[name] && formik?.errors[name] && (
				<ErrorText>{formik?.errors[name]}</ErrorText>
			)}
		</div>
	);
};

export default Textarea;
